let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("LFF6S")).then(() => parcelRequire('lYwlD'));